import { faqTypes } from '../types/faqTypes'

const initialState = {
  faqLoading: false,
  faq: [],
  error: '',
}

export const faqReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case faqTypes.FAQ_IS_LOADING:
      return {
        ...state,
        faqLoading: true,
      }

    case faqTypes.GET_FAQ_SUCCESS:
      return {
        ...state,
        faq: action.payload,
        faqLoading: false,
      }

    default:
      return state
  }
}
